// Small shared pieces: the logo, the LIVE badge and full-screen messages.
import type { LoadState } from "../lib/usePoll";
import type { PollStatus } from "@flp/core";
import { t } from "../i18n";
import { ThemeSwitch } from "./ThemeSwitch";

/** The LivePoll lockup as its image files (never retyped); CSS shows the one that fits the theme. */
export function Logo({ href }: { href: string }) {
  return (
    <a class="brand" href={href}>
      <img class="logo on-light" src="/assets/brand/logo-light.png" alt={t("app.name")} width={420} height={148} />
      <img class="logo on-dark" src="/assets/brand/logo-dark.png" alt={t("app.name")} width={420} height={166} />
    </a>
  );
}

export function LiveBadge({ status }: { status: PollStatus }) {
  const live = status === "live" || status === "waiting";
  const soon = status === "scheduled";
  return (
    <span class={`live-badge${live ? " on" : soon ? " soon" : ""}`}>
      <span class="dot" aria-hidden="true" />
      {live ? t("poll.live") : soon ? t("poll.soon") : t("poll.closed")}
    </span>
  );
}

export function PollMessage({ load, message, framed = false }: { load: LoadState; message?: string; framed?: boolean }) {
  const text =
    message ??
    (load === "loading"
      ? t("common.loading")
      : load === "not_found"
        ? t("poll.not_found")
        : load === "gone"
          ? t("poll.gone")
          : load === "region"
            ? t("region.body")
            : t("create.errors.server"));
  return (
    <main class={`message${load === "loading" ? " loading" : ""}`}>
      {load !== "loading" && !framed && (
        <>
          <div class="theme-float">
            <ThemeSwitch />
          </div>
          <Logo href="/new" />
        </>
      )}
      {load === "region" && <h1>{t("region.title")}</h1>}
      <p>{text}</p>
      {load !== "loading" && load !== "region" && (
        <a class="btn ghost" href="/new">
          {t("vote.make_your_own")}
        </a>
      )}
    </main>
  );
}
